import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const SweetWaterIcon = () => (
  <Svg width={40} height={41} viewBox='0 0 40 41' fill='none'>
    <Path
      d='M26.6668 23.064C26.6668 25.104 25.8767 27.0606 24.4702 28.5031C23.6717 29.3221 22.7115 29.9378 21.6667 30.3166M31.6667 23.5765C31.6667 12.6149 20 4.08929 20 4.08929C20 4.08929 8.33334 12.6149 8.33334 23.5765C8.33334 26.8066 9.56251 29.9048 11.7504 32.189C13.9384 34.473 16.906 35.755 20.0002 35.755C23.0943 35.755 26.0617 34.4723 28.2495 32.1883C30.4375 29.9041 31.6667 26.8066 31.6667 23.5765Z'
      stroke='#FE5000'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
